import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useExternalRegistrationApi } from '../../../api/external-registration/useExternalRegistrationApi';

import RegistrationSuccess from '../../../components/screens/auth/registration-success/RegistrationSuccess';

const RegistrationSuccessContainer = () => {
  const { programmeExternalReference, memberExternalReference } = useParams();

  const { flagMemberAsPaid } = useExternalRegistrationApi();

  useEffect(() => {
    flagMemberAsPaid({
      memberExternalReference: memberExternalReference!,
      programmeExternalReference: programmeExternalReference!
    });
  }, [flagMemberAsPaid, programmeExternalReference, memberExternalReference]);

  return <RegistrationSuccess />;
};

export default RegistrationSuccessContainer;
